import React from 'react'
import PropTypes from 'prop-types'
import DtoUser from '../dto/DtoUser'
import ActionComponent from '../../components/ActionComponent'
//import { NOTIF } from '../../components/actions/constants/ActionConstants'
//import i18n from 'simple-react-i18n'
import AppStore from '../../store/AppStore'
import AdministrationAction from '../../administration/actions/AdministrationAction'
//import NotifNewsComponent from '../../administration/components/notifs/NotifNewsComponent'
import NewsDto from '../../administration/dto/NewsDto'
import { connect } from 'react-redux'
import { differenceWith, isEqual } from 'lodash'

const $ = window.$

class MainApp extends ActionComponent {
	constructor(props) {
		super(props)
		AppStore.dispatch(AdministrationAction.fetchNews())
	}

	readNews = (news, notifs) => {
		if (notifs) {
			AppStore.dispatch(AdministrationAction.readNews(news))
		}
	}

	createOrUpdateActions = (/*news*/) => {
		/*const notifs = news.filter(o => o.status).length
        this.setAction([
      {
        type: NOTIF,
                notifs,
                title: i18n.news,
                fn: () => this.readNews(news, notifs),
                icon: 'event',
                content: <NotifNewsComponent key='notif-news-list' news={ news }/>
      }
    ])*/
	}

	componentDidMount() {
		this.createOrUpdateActions(this.props.news)
		$('body').css({
			/*'background-image': 'url(https://www.aquasys.fr/wp-content/uploads/2022/07/Illustration%20aQuaDB%20DEF-01.jpg)',*/
			'background-image': 'url(https://www.aquasys.fr/wp-content/uploads/2018/01/Visuel-inscription-beta-test-sans-texte.png)',
			'background-repeat': 'no-repeat',
			'background-attachment': 'fixed',
			'background-size': '100% 125%'
		})
	}

	componentWillReceiveProps(nextprops) {
		const diff = differenceWith(nextprops.news, this.props.news, isEqual)
		if (diff.length) {
			this.createOrUpdateActions(nextprops.news)
		}
	}

	render() {
		return (
			<div>
				{ this.props.children && React.cloneElement(this.props.children, {
					login: this.props.login, user: this.props.user, typeId: this.props.typeId, isLogged: this.props.isLogged
				}) }
			</div>
		)
	}

	componentWillUnmount() {
		$('body').removeAttr('style')
		this.setAction([])
	}
}

MainApp.propTypes = {
	children: PropTypes.element,
	isLogged: PropTypes.bool,
	typeId: PropTypes.number,
	user: PropTypes.instanceOf(DtoUser),
	login: PropTypes.string,
	news: PropTypes.arrayOf(PropTypes.instanceOf(NewsDto))
}

const mapStateToProps = store => {
	return {
		news: store.AdministrationReducer.news
	}
}

export default connect(mapStateToProps)(MainApp)



// WEBPACK FOOTER //
// ./src/home/components/MainApp.js